import React, { useState } from "react";
import "./AddCourtPopup.css"; // <-- we will style here
export default function AddCourtPopup({ onAddCourt }) {
  const [showPopup, setShowPopup] = useState(false);
  const [newCourt, setNewCourt] = useState({ courtName: "", location: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onAddCourt(newCourt); // call parent function
    setNewCourt({ courtName: "", courtType: "" ,location: "", city: "", state: "" });
    setShowPopup(false);
  };

  return (
    <div>
      {/* Button to open popup */}
      <button onClick={() => setShowPopup(true)}>Add Court</button>

      {/* Popup */}
      {showPopup && (
        <div className="popup-overlay">
            <div className="popup-container">
            <h2 className="popup-title">Add Court</h2>
            <form onSubmit={handleSubmit} className="popup-form">              
              <input
                type="text"
                placeholder="Court Name"
                value={newCourt.courtName}
            onChange={(e) =>
                  setNewCourt({ ...newCourt, courtName: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="Court Type"
                value={newCourt.courtType}
                onChange={(e) =>
                  setNewCourt({ ...newCourt, courtType: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />              
              <input
                type="text"
                placeholder="Location"
                value={newCourt.location}
                onChange={(e) =>
                  setNewCourt({ ...newCourt, location: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="City"
                value={newCourt.city}
                onChange={(e) =>
                  setNewCourt({ ...newCourt, city: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <input
                type="text"
                placeholder="State"
                value={newCourt.state}
                onChange={(e) =>
                  setNewCourt({ ...newCourt, state: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <div className="popup-buttons">
                <button type="submit" className="btn-save">Save</button>
                <button type="button" className="btn-cancel" onClick={() => setShowPopup(false)} style={{ marginLeft: "10px" }}>Cancel</button>                
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
